"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = areaGroupReducer;

var _processAreaStores = require("./../utils/processAreaStores");

var _processAreaStores2 = _interopRequireDefault(_processAreaStores);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    reducer: areaGroupReducer
}; /**
    * Reducer pro použití jako skupina standardních (např. list nebo detail) reducerů.
    */

var __AGR_INIT = "___AGR_INIT";

function areaGroupReducer(state) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: __AGR_INIT };

    if (action.area) {
        return (0, _processAreaStores2.default)(state, action);
    }

    switch (action.type) {
        case __AGR_INIT:
            {
                return (0, _extends3.default)({}, initialState, state);
            }
        default:
            return state;
    }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvc2hhcmVkL0FyZWFHcm91cFJlZHVjZXIuanN4Il0sIm5hbWVzIjpbImFyZWFHcm91cFJlZHVjZXIiLCJpbml0aWFsU3RhdGUiLCJyZWR1Y2VyIiwiX19BR1JfSU5JVCIsInN0YXRlIiwiYWN0aW9uIiwidHlwZSIsImFyZWEiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7a0JBWXdCQSxnQjs7QUFSeEI7Ozs7OztBQUVBLElBQU1DLGVBQWU7QUFDakJDLGFBQVNGO0FBRFEsQ0FBckIsQyxDQU5BOzs7O0FBVUEsSUFBTUcsYUFBYSxhQUFuQjs7QUFFZSxTQUFTSCxnQkFBVCxDQUEwQkksS0FBMUIsRUFBOEQ7QUFBQSxRQUE3QkMsTUFBNkIsdUVBQXBCLEVBQUNDLE1BQU1ILFVBQVAsRUFBb0I7O0FBQ3pFLFFBQUlFLE9BQU9FLElBQVgsRUFBaUI7QUFDYixlQUFPLGlDQUFrQkgsS0FBbEIsRUFBeUJDLE1BQXpCLENBQVA7QUFDSDs7QUFFRCxZQUFRQSxPQUFPQyxJQUFmO0FBQ0ksYUFBS0gsVUFBTDtBQUFpQjtBQUNiLGtEQUNPRixZQURQLEVBRU9HLEtBRlA7QUFJSDtBQUNEO0FBQ0ksbUJBQU9BLEtBQVA7QUFSUjtBQVVIIiwiZmlsZSI6IkFyZWFHcm91cFJlZHVjZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIFJlZHVjZXIgcHJvIHBvdcW+aXTDrSBqYWtvIHNrdXBpbmEgc3RhbmRhcmRuw61jaCAobmFwxZkuIGxpc3QgbmVibyBkZXRhaWwpIHJlZHVjZXLFry5cbiAqL1xuXG5pbXBvcnQgcHJvY2Vzc0FyZWFTdG9yZXMgZnJvbSBcIi4vLi4vdXRpbHMvcHJvY2Vzc0FyZWFTdG9yZXNcIjtcblxuY29uc3QgaW5pdGlhbFN0YXRlID0ge1xuICAgIHJlZHVjZXI6IGFyZWFHcm91cFJlZHVjZXIsXG59O1xuXG5jb25zdCBfX0FHUl9JTklUID0gXCJfX19BR1JfSU5JVFwiO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBhcmVhR3JvdXBSZWR1Y2VyKHN0YXRlLCBhY3Rpb24gPSB7dHlwZTogX19BR1JfSU5JVH0pIHtcbiAgICBpZiAoYWN0aW9uLmFyZWEpIHtcbiAgICAgICAgcmV0dXJuIHByb2Nlc3NBcmVhU3RvcmVzKHN0YXRlLCBhY3Rpb24pO1xuICAgIH1cblxuICAgIHN3aXRjaCAoYWN0aW9uLnR5cGUpIHtcbiAgICAgICAgY2FzZSBfX0FHUl9JTklUOiB7XG4gICAgICAgICAgICByZXR1cm4ge1xuICAgICAgICAgICAgICAgIC4uLmluaXRpYWxTdGF0ZSxcbiAgICAgICAgICAgICAgICAuLi5zdGF0ZVxuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICAgIGRlZmF1bHQ6XG4gICAgICAgICAgICByZXR1cm4gc3RhdGU7XG4gICAgfVxufVxuXG4iXX0=